import { useEffect, useState } from 'react';
import styles from '../styles/workExp.module.css';
import data from '../data/template.json';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { MdWork } from "react-icons/md";
import { TbSchool } from "react-icons/tb";

const WorkExp = () => {
  const [interns, setInterns] = useState({});
  let companies = Object.keys(data.experience);
  const [active, setActive] = useState({});
  useEffect(() => {
    setInterns({ ...data.experience });
    setActive(companies[0]);
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.heading}>Work Experience</div>
        <div className={styles.Card}>
         
<VerticalTimeline animation={true}>
  
<VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'black', color: '#fff',border: '1px solid  #63fbd7' }}
    contentArrowStyle={{ borderRight: '7px solid  #63fbd7' }}
    date="April 2024"
    iconStyle={{ background: 'black', color: '#fff' }}
    icon={<MdWork />}
  >
    <div className={styles.companyDiv}>
      <div className={styles.companyLogo}>
        <img src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxIREhUQExMSFhUXEhAZFxUYEBIVExUVFREWFhYXFRUYHSggGholHhUVITEhJSkrLi4vFx8zODMsNygtLisBCgoKDg0OGxAQGy0lICUuLS4rKy0tLS0tLS4yLS0tLS0tLy0tLS0tLS0tLS0tLS0tLS0tLi0tLS0tLS0tLS0tLf/AABEIAOEA4QMBIgACEQEDEQH/xAAcAAEAAQUBAQAAAAAAAAAAAAAABgEDBAUHAgj/xABDEAACAQIBCQQHBgIKAwEAAAAAAQIDEQQFBhIhMUFRYXEykaGxEyJCUoHB0QcUYnKS8CNzMzRDgoOTorLh8SRTYxb/xAAbAQEAAgMBAQAAAAAAAAAAAAAABAUCAwYBB//EADgRAAIBAQQHBgUDAwUAAAAAAAABAgMEESExBRJRcZGx0UFhgaHB8BMiIzLhM0LxFHKSFSRSYoL/2gAMAwEAAhEDEQA/AO4gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoAACoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAAAqAAAAAAAAAAAADDyhlCnQjp1JKK3cW+CW8heVs9py9WhHQXvSSc/gtaXiaateFP7n4dpIoWWpW+xYbez3uvJ5VqRiryaS4tpLvZrK+cWEhtrwf5Xp/wC25yzKGUpzelVnKb5tvuW41dXFSezUvEjK1zl9kcO/8FrS0On90uGHPodaqZ6YOO2cv0M8f/u8D/7Jf5UjkTYjFvYr9DNVqnby/JKWhaG2Xl0OtrP3A+/P/LkZeGztwU/7eEfztw73LUcceHl7sv0s8WfBnqry7g9C0H9rlxT9Dv2HrwmtKEoyT2OMk0/ii8cBwmMqUnpU5zg+Km1322ktyL9oFanaNdelXvJKM11tqZmrQu1ECtoarFX03reT6HUQa3JWWaOJipU5J8t5sjdGSkr0VMouL1ZK5gAGRiAAAAAAAAAUAABUAAAAAAAAAj+cecUMKtCNpVWtUd0eDn9NrK50ZdWGhaNnUl2VwXvPl5nM6tRyk5Sbcm2227tt72QrVadT5IZ8iysNi+L88/t5/gvY7G1K03UqScpPuS4Jbka7E4jR1Lb5HrE1tFc3s+phUKUpyUYpuTZApwvvlL3vOipwSV7yXDpgebtvi2bfAZv1J+tN6K4e0/huN7kbISppSdnP3mrpco/U3E6cIK8n8u5G5QtFb9GNy2vC/csX5FJbdOKLcaP+XRZLx4Lt02GyPRp7I6T4ySb+hnRglqSS6Kxar5RjshBdX9DDni5bb27kevQVpnjKcfG/oc5V0nGbvm3LfjzZsrHirRjLVKKfVJms+/P3/Iu08e+MWa6mgbVBXx1Xudz80l5muGkKN+zh6O8t4vINGeuN4vla3xTNBlDI9SjrtpR95X8eBKqWOi9T9V89neZTRCVavQlqzT3P313F7ZdLVoZS1o7H1zXLuIJgMdOjLTg7cVufU6bm1nUqsUpvZZP3ovnxXMhuWchqzqUlbjBLbzjbyNJgcXKjNSjtW1bmt6ZOp1dda9J3P3g/TyLqUaGkKWtHNcV3P0O8wkmrp3T2M9kNzfy3aMZJt05bVvi99ufIl8JppNO6exlhZ7RGqsMGs0c5WoypSuZ7ABINIAAAAABQAAFQAAAAADGx2LjSpyqz7MU2/ouZkkF+0LKV9HDRey059fZT8X3GqvU+HByN9mo/GqKHHd7wIrlPHTr1JVZ7ZPZuS3RXJGI2VMfGztG3Eo0nOW86mMVhFYGJVnpPyJxm7kZUY6c1/Elt/CuBpsz8l6c/TyXqxfq856tfReZNC5oWeLSlJYdiKPTlvx/pqbwX3ei9Xw7MbWKxCpx0n8FxZHsRXlN3k/ouhcyhiNObe5al9TX4qrZW3+SLulTu3nF162b7EUr4m2pbeJiSk3tIllrO1RbhQtJrbUavH+4t/XZ1Izicq16jvKrV6KcoruR5O1QhgsTyGjq9Za0morY8+HW46mUOVUMpVoO8atRf4kmu56iSZIzvd1Guk178FZr88d/VCFsg3c8DGromtBXxuluz4E2p13seteJm4fFShsd48P3sNXTmpJSTTTSaa2NPei9RnbU9j/dzVb7DC008vm7Om7lmR7NapUpYvDkSShWU1df9GgzjyZb+LBavbXe9JfMuYau6cr964m79WceMZLwe1HE/NQmpLL3ejrrBbZU566zWa2ojea+O0Knom/Vns5S/5+h0TIWP0H6KT9VvVyf0ZyvKOHdGq0r9pOL5Xun++BNsDiPSU41OKT6Pf4k2c/hzjVh/P8/k6O3UoVYqaykv4fA6GDXZHxfpaav2o6n8n8TYl1CanFSWTOblFxbTAAMjEAAAoAACoAAAAAKSdtZx7K+L9NWqVfem2ui1R8Ejp+cNbQw1aS2+jklyclorzOSFbpCX2x8fTqXOioYSn4evQGFjHeSXLxZmlrAU9PFU4/8A1p9ykm/JkWzq+ZcxkoXzfYmyd5MwqpUoQW6OvnJ62+9nrHVNGnJ8vN2+ZkGHlj+ifWPmdJCKvSPnlapKSlOWbvfizQkCz7y00/u8HZvXNp61HdD47f8AsncnZN8mcVyjiXVqzqP2qkn8Ni8EiRaajjG5dpGsdBVKt7yjj49nq/AsAFJ3s7bbMri7J99nf2b1MpL7xUm6WGUmlJJOpVadpKF9UUnqcmnrTVt6mmdP2PYSOGqTwjqwrQhKS0qkpxqaKu4yT2XttWzg9h0PNONJYLDKjb0X3ejoW2W0ERv7Vs76eBws6MZL7xWhKNON9cYy9WVSS3JK9uLsgeHFsy8saMlQk/Un2L+zPh0fn1Jucioy0WmtsWmuTTuvI6vhK3pIQmvahF96uWVjqXxcX2HP6WoKE1UX7s966rl3mcnezM/JNez0Hsezqa2m9Xw+R7hKzTW5p9xzGkaS+PUj388TfZajUIyL2deHvGNRbmovpra8V4mRmnWvSlH3Zvukk/O5k5Vgp0Z/y7r4azV5ny11FyT8WQaT1rO1sZ3Fjnr2Jx/4vydz9Wia5DxOhVS3S9V9Xs8fMlpBE7aya4WrpwjPjFPwLHR1S+Lh4+/faVtsjipF4AFmQgAACgAAKgAAAAAj+e87YSfOVNf6jmJ0zPtf+JL89PzOZlRbv1fD1Zf6L/Q8XyQPGSNWLp/zI+J7Mek9GvCX4oPukvoarPLVlf7wxJ9R/Sqf2y5HSDGyjT0qclyv3O5kQmpJNbGk+8qzpE7nefP2r1cQ/F30J226E7ddFnEYbF0R3nHYfQk47tdujOI5Vwjo1qlJ+zOS+G2Pg0Z2vHVkj3R+DnF54e+RigAhlkbfJWdGOwsHSoYmtTptt6EZLRu9tk07X5WNZXrSnJ1JylOcneUpScpSfFyetlsAA6Zm5/VaH8qHdbV4HNYQcmora2kurdkdWwlHQhGC9mEV3KxOsSd7fv3gU2mZXQgu9vh+TLp/I9FIoqc3aqqq1pTWTeG7JeRjRjqwUWbig70Jfy6i8zU5oL16j/CvNmxoSth5P8NX/azFzQp+rOXGVu5XfmiFDCFTf6s6/RT/ANpNv/ryJCSjN+d6KXCUl43+ZFyRZsv1JL8XyJFgd1bwfozG1L6fA3QALwrAAACgAAKgAAAAA0WedPSwlTlZ9zucuOv5ZpadCpH8L8NbOR1YaLcXubXcVFuX1Fu9WXmi5fTku88FmsrSjLhKPg7l481I6SZFjLVd5aYPB5PPdkyWZv4vSh6N7Y7Ocb/L6G3INgMTKOjNapJK/VKzXQmGBxkasbrbvW9Mu7HX1o/DlmvNHz+UJU5OnLNO7hgMdhFUjbetj+XQ5T9omb8v6zGPrRSVVb9FLVPnbZ0twOvFjFYWNRWkvjvLBSTjqyyMLnGSnHPmj5pB03Of7M5NurhHG71uk2ox/uvd08iC4zN3GUnaphqy6U3JfBxumR5QaLCFWMl6GsBnUci4meqOHrv/AAZrzRKcg/Z7Xm1KtCyv2FJa/wA0tnwVxGnKWXRGNSvCmsX4LF8EYGZmSHOf3iS9WPY/FPj0Xn0J1TjvL9TAwopU002rK0exG25cWWzRa7ZGnB0KP/qXNLr4YlPKE61X41RXbFs3894APVKGk1Fb2imvJBk5Qqejwlt8rL9Wk/K5n5CoejoQW9rSfWWv6Gvx0PTVoUFrjBaU+9XXdZfEkBHvugltd/TyOvs8PhWWEO1/M+Fy8kCRZsr1J/mXkR0k+b0bUb8ZSfdq+RKsC+t4M0Wp/T4G1ABeFYAAAUAABUAAAAAHipG6aexprvOUZw4R06rfFtP8y1HWiH53ZO0m/wAauuUkrfvqyv0hD5VPZ6/m4sNHVdSpc+0gIPUotOz2o8lYdAVpuz5PzZl0K8oPSi2n+9vEw0y9TkZxkc5pqxO/+ogv7uSe7sfg9rJLgstwlqn6r4+y/obSE1JXTTXFNNEIPUKjjsbXR2LGnb5rCav8jnlIm4Igso1V/aPvPE8bUltm/wBTN/8AqMNj8up7rEsxGMhDtSS5X19xo8oZalP1YXiuPtP6GobBFq22pNXLDnxPHJgAEMxBlUJKnCVWXC0Fxk/35lqhSTvKTtCPafyXMuYam8TVTatTh2Y8k9V+bsa5NPB5dvTx8kWujLF8afxJ/Ys+/uXvDPO42GRcK4Q05f0lR6Un12I2IBplJyd7L+UnJtsqTPBUtCEY8Irv3kXyRh9OrFbk9J9F/wA2JgWujaeEpvd1K62TxUQACzIQAABQAAFQAAAAADCyphPS03HetceqM0GM4qacXkz2MnFpo5blnAX/AIkVrXaXz6mjOlZewGi/SxWp9pcHx6Mh2U8l7Z01xvH5r6HP1IOlLUkdFZbSpxXvwNMADwml2Mz3cxz0ptbfNmSkUVr0JCb1qD1XseXhs3Y91ywLwPCqc/Arpr92MtZFLPRlrh+xvdc+V/U9AppLj4L6ldOPFv4JeN/kNZHkdG2uWVN+OHNpAuOCjrndcIrtP6Lmy08S/ZSjzV9Lv3fA80aEqkrRTb/etswci0sug391olhsXq+nE9tyrSjFLUuzFdmPNre+ZI8HhlTior4viy3gMEqS4ye1/JcjLNTd+CLSco3KEFdFZAA2WRcB6SWk16kXr5vge06cqklGOZpnNQV7NrkLB+jhpPtTs+i3I2oB0dOmqcVFdhTzk5SbYABmYgAAFAAAVAAAAAAAAB4nBNNNXT2oi2VcnOk7rXBvU+HJksPE4Jppq6e1Ee0WeNaNzz7GbaNV033dqOcY3JsKmvsy4rf1RpMVgZ0+0tXFa0dAylkZxvKndx932l9UagpKkJ0pas177i6oWm9XrFENBJ6+Tqc9sbPitRiTyHHdN/FJmOsSlaIPPA0YNs8hy99dzPUchvfNfpGsjL40NppwlfUiQUsi01tcn3JeBm0cPCHZil8NfeNZGErRFZYmkwmSJS1y9Vf6n8NxvMPh401aKt5vqy4DBtsjzqSnmADZZOyTKp60rxhx3vp9TKnTlUlqxV7NM5qCvZj5PwEq0rLVFbZcOnMltCjGEVGKskKFGMIqMVZIul5ZrMqK2t5v0XdzKytWdR9wABKNAAAAAABQAAFQAAAAAAAAAAADXY7JVOrr7MveS81vNiDGcIzV0lejKMnF3pkSxWR6sN2kuMdfhtMBqxPCzVw8J9qMX1SK+po5Zwd2/wB38yXG2P8AciEglE8iUXsUl0k/ncsvIEN05eBFdgrLZx6pG5Wqn38COgkSzeh78u5F2GQ6K26T6yt5BaPrPZxDtVP2iMmXhsmVamyNlxlqX1ZKKODpw7MIrnbX3mQSaejlnOXDqaZ2x/tXE1eByNTp65eu+a1LojaAFhTpxpq6KuIkpyk75MAAzMQAAAAAAAACgAAKgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoAACoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoAAD//2Q==" alt="logo" width="100%" height="auto" />
      </div>
      <div>
      <h3 className="vertical-timeline-element-title"><a href="https://github.com/nightwatchjs">Browser Stack 🔗</a></h3>
    <h2 className="vertical-timeline-element-subtitle" style={{color:"#00f7ffc2"}}>open source contributor</h2>
      </div>
    </div>
    <p>
      Contributing in Nightwatch.js E2E testing framework.
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'black', color: '#fff',border: '1px solid  #63fbd7' }}
    contentArrowStyle={{ borderRight: '7px solid  #63fbd7' }}
    date="Aug 2023 - Present"
    iconStyle={{ background: 'black', color: '#fff' }}
    icon={<MdWork />}
  >
     <div className={styles.companyDiv}>
      <div className={styles.companyLogo}>
        <img src="https://media.licdn.com/dms/image/C560BAQG04byOHEEBfg/company-logo_200_200/0/1630544475104?e=1721260800&v=beta&t=oaDqJTrmXE4oW-BHzLciQlmAdeLAiiXIRJM-AO7CCQ8" alt="logo" width="100%" height="auto" />
      </div>
      <div>
      <h3 className="vertical-timeline-element-title"><a href="https://stepsecurity.io">Step Security 🔗</a></h3>
    <h2 className="vertical-timeline-element-subtitle" style={{color:"#00f7ffc2"}}>Software Developer 💻</h2>
      </div>
    </div>
    <p>
      Plateform Enhancement and New feautre implementation 
    </p>
    <p>
      Mirgrated Reactjs to Nextjs 
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'black', color: '#fff',border: '1px solid  #63fbd7' }}
    contentArrowStyle={{ borderRight: '7px solid  #63fbd7' }}
    date="Dec 2023"
    iconStyle={{ background: 'black', color: '#fff' }}
    icon={<MdWork />}
  >
    <div className={styles.companyDiv}>
      <div className={styles.companyLogo}>
        <img src="https://avatars.githubusercontent.com/u/53581911?s=200&v=4" alt="logo" width="100%" height="auto" />
      </div>
      <div>
      <h3 className="vertical-timeline-element-title"><a href="https://github.com/stakwork">Stakwork & Sphinx 🔗</a></h3>
    <h2 className="vertical-timeline-element-subtitle" style={{color:"#00f7ffc2"}}>open source contributor</h2>
      </div>
    </div>
    <p>
      Feature Enhancement and Bug fixing 
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    contentStyle={{ background: 'black', color: '#fff',border: '1px solid  #63fbd7' }}
    contentArrowStyle={{ borderRight: '7px solid  #63fbd7' }}
    date="Jun 2023 - Oct 2023"
    iconStyle={{ background: 'black', color: '#fff' }}
    icon={<MdWork />}
  >
     <div className={styles.companyDiv}>
      <div className={styles.companyLogo}>
        <img src="https://media.licdn.com/dms/image/C510BAQFTcr_NHxvvvg/company-logo_200_200/0/1631439146012/stream_digital_services_logo?e=1721260800&v=beta&t=zug6wbJyzexq5JSQd-c6zmjJh44NAzLDI5di_uiWm2Y" alt="logo" width="100%" height="auto" />
      </div>
      <div>
      <h3 className="vertical-timeline-element-title"><a href="https://chatzy.ai">Stream Digital Services 🔗</a></h3>
    <h2 className="vertical-timeline-element-subtitle" style={{color:"#00f7ffc2"}}>Software Developer 💻</h2>
      </div>
    </div>
    <p>
      Created Chatzy.ai from scratch. 
    </p>
  
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    contentStyle={{ background: 'black', color: '#fff',border: '1px solid  #63fbd7' }}
    contentArrowStyle={{ borderRight: '7px solid  #63fbd7' }}
    date="May 2023"
    iconStyle={{ background: 'black', color: '#fff' }}
    icon={<MdWork />}
  >
    <div className={styles.companyDiv}>
      <div className={styles.companyLogo}>
        <img src="https://avatars.githubusercontent.com/u/67101730?s=200&v=4" alt="logo" width="100%" height="auto" />
      </div>
      <div>
      <h3 className="vertical-timeline-element-title"><a href="https://github.com/codedecks-in">Codedecks 🔗</a></h3>
    <h2 className="vertical-timeline-element-subtitle" style={{color:"#00f7ffc2"}}>open source contributor</h2>
      </div>
    </div>
    <p>
      Feature Enhancement and Bug fixing 
    </p>
    <p>
     Effected over 20k+ people everyday
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    contentStyle={{ background: 'black', color: '#fff',border: '1px solid  #63fbd7' }}
    contentArrowStyle={{ borderRight: '7px solid  #63fbd7' }}
    date="2020 - 2024"
    iconStyle={{ background: 'black', color: '#fff' }}
    icon={<TbSchool />}
  >
    <h3 className="vertical-timeline-element-title">Army Institute of Technology</h3>
    <h4 className="vertical-timeline-element-subtitle">Bachelor Degree</h4>
    <p>
      Mechenical Engineering 
    </p>
  </VerticalTimelineElement>
 
</VerticalTimeline>
        </div>
      </div>
    </div>
  );
};
export default WorkExp;
